module.exports = __webpack_public_path__ + "img/active-layer6.84631e67.png";